<template>
  <span
    class="ml-1 text-md bg-sky-500 text-white px-1 rounded font-semibold w-fit flex items-center py-0"
    v-tooltip="{ content: tooltipHtml || tooltip, html: !!tooltipHtml }"
    role="button"
  >
    +{{ parseFloat(value).toFixed(2) }}% | {{ label }}
  </span>
</template>

<script>
export default {
  props: ['value', 'label', 'tooltip', 'tooltipHtml']
};
</script>
